__turbopack_context__.v({
  "address": "InPersonLocation-module-scss-module__XIQQCG__address",
  "divider": "InPersonLocation-module-scss-module__XIQQCG__divider",
  "howToGetThere": "InPersonLocation-module-scss-module__XIQQCG__howToGetThere",
  "inPersonEventLocation": "InPersonLocation-module-scss-module__XIQQCG__inPersonEventLocation",
  "map": "InPersonLocation-module-scss-module__XIQQCG__map",
});
